/**
 * A Look Into the Process Custom Element
 * Self-initializing, editor-friendly web component wrapping the process steps grid/carousel.
 */
class ALookIntoTheProcess extends HTMLElement {
  connectedCallback() {
    this.carousel = this.querySelector('.process-section__grid.is-carousel');
    if (!this.carousel) return;
    
    // Bind slick initialization
    this.initSlick();
    
    // Handle resizing smoothly using ResizeObserver
    this.resizeObserver = new ResizeObserver(() => {
      this.initSlick();
    });
    this.resizeObserver.observe(this);
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  initSlick() {
    const $carousel = $(this.carousel);
    if (window.innerWidth < 1024) {
      if ($carousel.length > 0 && !$carousel.hasClass('slick-initialized')) {
        $carousel.slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          autoplay: false,
          dots: true,
          infinite: false,
          arrows: false,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    } else {
      if ($carousel.hasClass('slick-initialized')) {
        $carousel.slick('unslick');
      }
    }
  }
}

if (!customElements.get('a-look-into-the-process')) {
  customElements.define('a-look-into-the-process', ALookIntoTheProcess);
}

